import { render, staticRenderFns } from "./StaffLeadAssignment.vue?vue&type=template&id=1263972c"
import script from "./StaffLeadAssignment.vue?vue&type=script&lang=js"
export * from "./StaffLeadAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports